<template>
  <div class="conversation-add-user-container">
    <b-button icon-left="user-add" class="conversation-add-user" @click="openModal" />
    <b-modal v-model="modal" :width="640" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('newMessenger.addToConversation') }}
          </p>
          <button type="button" class="delete" @click="cancel()" />
        </header>
        <section class="modal-card-body">
          <b-autocomplete
            v-model="userName"
            :data="notAssignedUsers"
            field="name"
            placeholder="Wyszukaj użytkownika"
            icon="magnify"
            open-on-focus
            append-to-body
            clearable
            clear-on-select
            rounded
            @select="addUserToPending"
          >
            <template #empty>
              {{ $t('newMessenger.noItemsToDisplay') }}
            </template>
          </b-autocomplete>
          <div class="conversation-current-users">
            <h4>
              {{ $t('newMessenger.currentChatUsers') }}
            </h4>
            <div class="conversation-current-users-items">
              <div
                v-for="(user, index) in currentUsers"
                :key="`current_${index}`"
                class="conversation-current-users-item"
              >
                <div class="user-details">
                  <span>
                    {{ user.name }}
                  </span>
                  <span v-if="user.client">
                    ({{ $t('newMessenger.client') }})
                  </span>
                  <span>
                    {{ getEmail(user) }}
                  </span>
                </div>
                <div v-if="!user.client" class="user-actions">
                  <b-button size="is-small" @click="deleteFromCurrentUsers(index)">
                    {{ $t('newMessenger.delete') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="pendingUsers.length > 0" class="conversation-current-users">
            <h4>
              {{ $t('newMessenger.pendingUsers') }}
            </h4>
            <div class="conversation-current-users-items">
              <div
                v-for="(user, index) in pendingUsers"
                :key="`pending_${index}`"
                class="conversation-current-users-item"
              >
                <div class="user-details">
                  <span>
                    {{ user.name }}
                  </span>
                  <span v-if="user.client">
                    ({{ $t('newMessenger.client') }})
                  </span>
                  <span>
                    {{ getEmail(user) }}
                  </span>
                </div>
                <div v-if="!user.client" class="user-actions">
                  <b-button size="is-small" @click="deleteFromPendingUsers(index)">
                    {{ $t('newMessenger.back') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="deleteUsers.length > 0" class="conversation-current-users">
            <h4>
              {{ $t('newMessenger.deleteUsers') }}
            </h4>
            <div class="conversation-current-users-items">
              <div v-for="(user, index) in deleteUsers" :key="`delete_${index}`" class="conversation-current-users-item">
                <div class="user-details">
                  <span>
                    {{ user.name }}
                  </span>
                  <span v-if="user.client">
                    ({{ $t('newMessenger.client') }})
                  </span>
                  <span>
                    {{ getEmail(user) }}
                  </span>
                </div>
                <div v-if="!user.client" class="user-actions">
                  <b-button size="is-small" @click="deleteFromDeleteUsers(index)">
                    {{ $t('newMessenger.back') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button label="Zapisz" type="is-success" @click="addUserToTicket()" />
          <b-button label="Anuluj" @click="cancel()" />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'NewMessengerConversationAddUser',
  props: {
    ticket: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      modal: false,
      userName: '',
      notAssignedUsers: [],
      pendingUsers: [],
      deleteUsers: [],
      currentUsers: [],
      loading: false
    }
  },
  methods: {
    openModal () {
      this.modal = true
      this.setCurrentUsers()
      this.getNotAssignUsers()
    },
    async getNotAssignUsers () {
      this.loading = true
      await this.$api.messenger.seller.assign({ ticket: this.ticket.id })
        .then((res) => {
          res.forEach((user, index) => {
            user.name = user.firstName && user.lastName ? user.firstName + ' ' + user.lastName : user.email
          })
          this.notAssignedUsers = res
        })
        .catch(() => {
        })
        .then(() => {
          this.loading = false
        })
    },
    setCurrentUsers () {
      this.currentUsers = []
      this.currentUsers = this._clone(this.ticket.assignedEmployees)

      this.currentUsers.push(this.ticket.client)

      this.deleteUsers = []
      this.pendingUsers = []
    },
    addUserToPending (user) {
      const index = this.notAssignedUsers.findIndex(obj => obj.id === user.id)

      this.pendingUsers.push(this.notAssignedUsers[index])
      this.notAssignedUsers.splice(index, 1)
    },
    addUserToTicket () {
      this.modal = false

      const assignTo = this.pendingUsers
        .map(i => i.id)

      const unassignFrom = this.deleteUsers.map(i => i.id)

      this.$store.dispatch('websocket/assignRoomTo', { assignTo, unassignFrom, ticketId: this.ticket.id })
    },
    deleteFromCurrentUsers (index) {
      this.deleteUsers.push(this.currentUsers[index])
      this.currentUsers.splice(index, 1)
    },
    deleteFromPendingUsers (index) {
      this.notAssignedUsers.push(this.pendingUsers[index])
      this.pendingUsers.splice(index, 1)
    },
    deleteFromDeleteUsers (index) {
      this.currentUsers.push(this.deleteUsers[index])
      this.deleteUsers.splice(index, 1)
    },
    cancel () {
      this.modal = false
      this.deleteUsers = []
      this.pendingUsers = []
      this.notAssignedUsers = []
    },
    getEmail (user) {
      return (user === undefined) || (user.name && user.name?.includes('@')) ? '' : user.email ? '(' + user.email + ')' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
$conversation-users-item-hover-bg-color: #eeeeee;

.conversation-add-user-container {
  padding-left: 8px;
  border-left: 1px solid $conversation-users-item-hover-bg-color;
  .conversation-add-user {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    padding: 0;
    border-radius: 12px;

    :deep(i) {
      font-size: 14px !important;
    }
  }

  .modal-card {
    .modal-card-head {
      p {
        font-size: 20px;
        font-weight: 600;
      }
    }

    .modal-card-body {
      .conversation-current-users {
        margin-top: 24px;

        h4 {
          margin-bottom: 8px;
          font-weight: 600;
        }

        .conversation-current-users-items {
          display: flex;
          flex-direction: column;
          font-size: 14px;

          .conversation-current-users-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            height: 38px;
            padding: 0 8px;

            &:hover {
              background-color: $conversation-users-item-hover-bg-color;
            }

            &:not(:last-child) {
              border-bottom: 1px solid $conversation-users-item-hover-bg-color;
            }

            .user-details {
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
}</style>
